<script setup>
import {computed} from 'vue'

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  min: {
    type: [Number, String],
    default: 1,
  },
  modelValue: {
    type: Number,
    default: null,
  },
})

function decrement() {
  if (amount.value > 1) {
    amount.value -= 1
  }
}

const emit = defineEmits(['update:modelValue'])

const amount = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', Math.max(value, props.min))
  },
})
</script>

<template>
  <div class="quantity-selector">
    <span class="quantity-selector__minus" @click="amount -= 1">-</span>
    <input
        class="quantity-selector__amount"
        type="number"
        :min="min"
        v-model="amount"
        @focus="$event.target.select()"
        v-bind="$attrs"
    />
    <span class="quantity-selector__plus" @click="amount += 1">+</span>
  </div>
</template>

<style scoped lang="scss">
.quantity-selector {
  border-radius: 2px;
  border: 1px solid var(--neutral-300, #C4C3C1);
  background: var(--shades-white, #FFF);
  display: flex;
  align-items: center;
  color: var(--neutral-1000, #3C3833);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 166.667% */
  letter-spacing: 1.2px;
  text-transform: uppercase;

  .quantity-selector__minus {
    cursor: pointer;
    padding: 14px 16px;

    @media screen and (min-width: 768px) {
      padding: 14px 23px;
    }
  }
  .quantity-selector__plus {
    cursor: pointer;
    padding: 14px 16px;

    @media screen and (min-width: 768px) {
      padding: 14px 23px;
    }
  }

  .quantity-selector__amount::-webkit-outer-spin-button,
  .quantity-selector__amount::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .quantity-selector__amount {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
    outline: none;
    border: 0;
    background: var(--shades-white, #FFF);
    max-width: 36px;
    color: var(--neutral-1000, #3C3833);
    text-align: center;
  }
}
</style>
